import React from 'react';

export const CalmNote = ({ note, palette, bodyFont, headingFont, c }) => (
  <div>
    <div style={{
      display: 'flex', alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 12, marginBottom: 4,
    }}>
      <h3 style={{
        margin: 0,
        fontFamily: headingFont,
        fontSize: '0.98rem',
        fontWeight: 600,
        color: c.textPrimary,
        lineHeight: 1.3,
      }}>{note.title}</h3>
      {note.pinned && (
        <span style={{
          fontFamily: bodyFont,
          fontSize: '0.68rem',
          color: c.warning,
          padding: '2px 8px',
          borderRadius: 999,
          background: `${c.warning}1a`,
          border: `1px solid ${c.warning}44`,
          letterSpacing: '0.04em',
          fontWeight: 600,
          flex: '0 0 auto',
        }}>Pinned</span>
      )}
    </div>
    <p style={{
      margin: 0,
      fontFamily: bodyFont,
      fontSize: '0.86rem',
      color: c.textSecondary,
      lineHeight: 1.55,
    }}>{note.body}</p>
    <div style={{
      marginTop: 8,
      fontFamily: bodyFont,
      fontSize: '0.74rem',
      color: c.textMuted,
    }}>
      <span style={{ color: palette.light }}>{note.author}</span>
      <span> · {note.timeAgo}</span>
    </div>
  </div>
);
